$ = jQuery = require('jquery');
module.exports = require('./select2.js');